// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import { Checkbox } from '@mui/material';
import MDInput from "components/MDInput";
import * as service from '../../../services/service';

function SupplierMaterialMap() {
    const [data, setData] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
    const [supplierId, setSupplierId] = useState('');
    const [materialCategoryData, setMaterialCategoryData] = useState([]);
    const [materialSubCategoryData, setMaterialSubCategoryData] = useState([]);
    const [materialCategoryId, setMaterialCategoryId] = useState('');
    const [materialSubCategoryId, setMaterialSubCategoryId] = useState('');
    const [materialIds, setMaterialIds] = useState([]);
    const [rate, setRate] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    // const navigate = useNavigate();

    const getSuppliers = () => {
        fetch(
            service.SUPPLIER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({

                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.supplierId, label: item.supplierName }));
                setSupplierData(data2);
            });
    };

    const getMaterialCategories = () => {
        fetch(
            service.MATERIAL_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialCategoryId, label: item.materialCategory }));
                setMaterialCategoryData(data2);
            });
    };
    const getMaterialSubCategories = (id) => {
        fetch(
            service.MATERIAL_SUB_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    materialCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialSubCategoryId, label: item.materialSubCategory }));
                setMaterialSubCategoryData(data2);
            });
    };

    const getDetails = (id) => {
        if (id > 0) {
            fetch(
                service.GET_SUPPLIER_MATERIAL_MAP,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        SupplierId: supplierId.value,
                        MaterialCategoryId: materialCategoryId.value,
                        MaterialSubCategoryId: id
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setData(result);
                    result.forEach((element, index) => {
                        materialIds[index] = element.materialId;
                        setMaterialIds([...materialIds]);
                        isSelected[index] = element.isSelected;
                        setIsSelected([...isSelected]);
                        rate[index] = element.rate;
                        setRate([...rate]);
                    });
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };
    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!supplierId) {
            isValid = false;
            errs[".supplierId"] = "Please select supplier";
        }
        if (!materialCategoryId) {
            isValid = false;
            errs[".materialCategoryId"] = "Please select material category";
        }
        if (!materialSubCategoryId) {
            isValid = false;
            errs[".materialSubCategoryId"] = "Please select material sub category";
        }
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".materialId"] = "Please select material";
        }
        setErrors(errs);
        return isValid;
    }

    const submitHandler = e => {
        if (validate()) {
            // eslint-disable-next-line
            console.log(materialIds); // do not remove
            e.preventDefault();
            const errs = {};
            setLoading(true);
            let flag = true;
            fetch(
                service.DELETE_SUPPLIER_MATERIAL_MAP,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        SupplierId: supplierId.value,
                        MaterialCategoryId: materialCategoryId.value,
                        MaterialSubCategoryId: materialSubCategoryId.value
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/supplier/suppliermaterialmap');
                    }
                    else if (result.messageType === 'Success') {
                        materialIds.forEach((element, index) => {
                            if (isSelected[index] === true) {
                                fetch(
                                    service.ADD_SUPPLIER_MATERIAL_MAP,
                                    {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            SupplierId: supplierId.value,
                                            MaterialId: element,
                                            Rate: rate[index],
                                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId
                                        })
                                    })
                                    .then(resp => resp.json())
                                    .then(respo => {
                                        if (respo.messageType === 'Failed') {
                                            flag = false;
                                            // eslint-disable-next-line
                                            alert(respo.message);
                                            // navigate('/supplier/suppliermaterialmap');
                                        }
                                        else {
                                            flag = false;
                                            errs[".invalid"] = respo.message.message;
                                            setErrors(errs);
                                        }
                                    });
                            }
                        });
                        if (flag) {
                            // eslint-disable-next-line
                            alert("Data Saved Successfully");
                            // navigate('/masters/operationmachinemap');
                            window.location.reload(false);
                        }
                    }
                });
            setLoading(false);
        }
    }

    const supplierChangeHandler = (ev) => {
        setSupplierId(ev);
        setMaterialSubCategoryId(null);
        setData([]);
        setMaterialIds([]);
        setIsSelected([]);
    }
    const materialCategoryChangeHandler = (ev) => {
        setMaterialCategoryId(ev);
        setMaterialSubCategoryId(null);
        getMaterialSubCategories(ev.value);
        setData([]);
        setMaterialIds([]);
        setIsSelected([]);
    }
    const materialSubCategoryChangeHandler = (ev) => {
        setMaterialSubCategoryId(ev);
        setData([]);
        setMaterialIds([]);
        setIsSelected([]);
        getDetails(ev.value);
    }
    useEffect(() => {
        setLoading(true);
        getSuppliers();
        getMaterialCategories();
        setLoading(false);
    }, []);

    const rateChangeHandler = (event, index) => {
        if (Number.isNaN(parseFloat(event.target.value))) {
            // eslint-disable-next-line
            alert("Please enter numbers only");
            event.target.value = ""; // eslint-disable-line no-param-reassign
        }
        else {
            let updatedObject = rate[index];
            updatedObject = event.target.value;
            rate[index] = updatedObject;
        }

        setRate([...rate]);
    };
    const handleCheckboxChange = (checked, index) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);
    }

    const clearHandler = () => {
        setSupplierId(null);
        setMaterialCategoryId(null);
        setMaterialSubCategoryId(null);
        setData([]);
        setMaterialIds([]);
        setIsSelected([]);
        setErrors('');
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Supplier Material Mapping
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>

                                <Table aria-label="simple table">
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px' }}>Supplier :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                options={supplierData}
                                                name="supplier"
                                                value={supplierId}
                                                onChange={supplierChangeHandler}
                                                placeholder="Select Supplier"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".supplierId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '25%' }}>Material Category :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={materialCategoryData}
                                                name="materialCategory"
                                                value={materialCategoryId}
                                                onChange={materialCategoryChangeHandler}
                                                placeholder="Select Material Category"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialCategoryId"]}</div>
                                        </TableCell>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '15%' }}>Material Sub Category :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={materialSubCategoryData}
                                                name="materialSubCategory"
                                                value={materialSubCategoryId}
                                                onChange={materialSubCategoryChangeHandler}
                                                placeholder="Select Material Sub Category"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialSubCategoryId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <br />
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material Sub Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Rate</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.materialId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            <Checkbox checked={isSelected[index] || false}
                                                                onChange={(e) => handleCheckboxChange(e.target.checked, index)} id="chkSelect" />
                                                        </TableCell>
                                                        <TableCell>{row.materialCategory}</TableCell>
                                                        <TableCell>{row.materialSubCategory}</TableCell>
                                                        <TableCell>{row.material}</TableCell>
                                                        <TableCell>
                                                            <MDInput label="Rate" fullWidth value={rate[index] || ''}
                                                                name="rate"
                                                                onChange={ev => rateChangeHandler(ev, index)}
                                                                id="rate"
                                                            />
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".rate"]}</div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialId"]}</div>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Purchase'
                                                || userDesignation === 'Jr Mgr - Purchase' || userDesignation === 'Manager - Purchase'
                                                || userDesignation === 'Sr Mgr - Purchase' || userDesignation === 'MD'
                                                || userDesignation === 'Bussiness Development and Operations' ?
                                                <MDButton color="info" onClick={submitHandler}>
                                                    SAVE
                                                </MDButton>
                                                : null}
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                Clear
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default SupplierMaterialMap;